import {GridSortModel, GridValueFormatterParams} from '@mui/x-data-grid';
import {Async, isAsyncServerError, isLoaded} from 'Core/models/Async';
import {CommissionReportGridData} from '../../ducks/a360Commissions';
import {formatCurrency} from 'Shared/utilities/FormatMoney';

export const getResultsAndCount = <T>(reportsData: Async<CommissionReportGridData<T>>) => {
  if (isLoaded(reportsData)) {
    return {
      rows: reportsData?.Data?.results,
      totalCount: reportsData?.Data?.totalCount,
      loading: false,
    };
  }

  if (reportsData?.key === 'Loading') {
    return {
      loading: true,
    };
  }

  if (isAsyncServerError(reportsData)) {
    return {
      error: reportsData?.errorDetails,
    };
  }

  return {
    rows: [] as T[],
    totalCount: 0,
    loading: false,
    error: false,
  };
};

export const getSortField = (sortModel: GridSortModel, defaultSortField: string) => {
  if (!sortModel?.[0]?.field) {
    return [defaultSortField];
  }
  return sortModel?.[0]?.sort === 'desc' && sortModel?.[0]?.field
    ? [`-${sortModel?.[0]?.field}`]
    : [sortModel?.[0]?.field];
};


export const currencyValueFormatter = (params: GridValueFormatterParams) => formatCurrency(params.value);

export const extractProducerCodes = (producers: string[]) => producers?.map(a => a?.split(' - ')?.[0]);

const NO_EMPLOYER: string = 'No Employer';
export const replaceEmptyNamesWithNoEmployer = (list: string[]): string[] => {
  if (Array.isArray(list) && list.length > 0) {
    const uniqueArr = list.filter((value, index, self) => self.indexOf(value) === index);
    return uniqueArr.map(name => (name.trim() !== '' ? name : NO_EMPLOYER));
  } else return [];
}

export const revertNoEmployerToEmpty = (list: string[]): string[] => 
  Array.isArray(list) ? list?.map(name => (name === NO_EMPLOYER ? '' : name)) : [];
